import React from 'react';
import { theme } from '@citygross/design-tokens';
import { Radio } from '../FormElements/Radio/Radio.js';
import { BaseRadioBox } from './RadioBoxItem.styles.js';

var RadioBoxItem = function RadioBoxItem(_a) {
  var _b, _c, _d;

  var _e = _a.align,
      align = _e === void 0 ? 'flex-start' : _e,
      _f = _a.background,
      background = _f === void 0 ? (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.white : _f,
      _g = _a.border,
      border = _g === void 0 ? (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.border : _g,
      _h = _a.boxShadow,
      boxShadow = _h === void 0 ? true : _h,
      checked = _a.checked,
      children = _a.children,
      _j = _a.hideRadioButton,
      hideRadioButton = _j === void 0 ? false : _j,
      flexDirection = _a.flexDirection,
      isDisabled = _a.isDisabled,
      name = _a.name,
      _k = _a.padding,
      padding = _k === void 0 ? (_d = theme.spacings) === null || _d === void 0 ? void 0 : _d.md : _k,
      _l = _a.radioColor,
      radioColor = _l === void 0 ? 'alertGreen' : _l,
      setActive = _a.setActive;
  return React.createElement(BaseRadioBox, {
    align: align,
    "aria-checked": checked,
    background: background,
    border: border,
    boxShadow: boxShadow,
    checked: checked,
    flexDirection: flexDirection,
    isDisabled: isDisabled,
    onClick: !isDisabled ? setActive : undefined,
    onKeyDown: !isDisabled && setActive ? function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        if (e.key === ' ') e.preventDefault();
        setActive();
      }
    } : undefined,
    padding: padding,
    role: "radio",
    tabIndex: 0
  }, !hideRadioButton && React.createElement(Radio, {
    checked: checked,
    customColor: radioColor,
    disabled: isDisabled,
    name: name,
    onChange: setActive !== null && setActive !== void 0 ? setActive : undefined
  }), children);
};

export { RadioBoxItem };